const fromStoreResultToStore = (storeResultData)=>{
    const { code , name , shortName , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , lat , lon , phone , slug , distance , wheelchairAccessible , hearingAppointmentPossible ,  } = storeResultData;
    return {
        code,
        name,
        shortName,
        streetName,
        town,
        country,
        phone,
        streetNumber,
        additionalStreetInfo,
        postalCode,
        province,
        lat,
        lon,
        emailAddress: undefined,
        appointmentTypes: [],
        slug: slug !== null && slug !== void 0 ? slug : undefined,
        distance: distance !== null && distance !== void 0 ? distance : undefined,
        wheelchairAccessible,
        hearingAppointmentPossible
    };
};

export { fromStoreResultToStore };
//# sourceMappingURL=from-store-result-to-store.js.map
